import React, { useEffect, useState } from 'react';
import ProjectCard from './ProjectCard';
import ProjectPage from '../ProjectPageComponent/ProjectPage';
import './ProjectCardList.scss';
import Select from 'react-select';
import { FaFilter } from 'react-icons/fa';
import { MdDateRange } from 'react-icons/md';
import { useStateValue } from '../../services/ContextProvider';
import { getAllProjects } from '../../services/ProjectService';
import { useHistory, Link } from 'react-router-dom';
import queryString from 'query-string';
import Button from '../Button/Button';

const ProjectCardList = () => {


    const [projectyear, setProjectyear] = useState('2022/2023');
    const [projectList, setProjectList] = useState([]);
    const [proId, setProId] = useState('');
    const [viewingYear, setViewingYear] = useState({ value: '2022/2023', label: '2022/2023' });
    const yearOption = [
        { value: '2021/2022', label: '2021/2022' },
        { value: '2022/2023', label: '2022/2023' }
    ];

    const { allprojetsState, allprojectsDispatch, userState } = useStateValue();
    const [checkProject, setCheckProject] = useState(false);
    const [checkAdmin, setCheckAdmin] = useState(false);
    const history = useHistory();
    const locationPath = history.location;
    const [clubProjecttId, setClubProjecttId] = useState('');

    useEffect(() => {
        var projectId = queryString.parse(locationPath.search);
        setProId(projectId._id);
    }, [locationPath]);

    useEffect(async () => {
        if (allprojetsState.allprojectList) {
            await getAllProjects(allprojectsDispatch, allprojetsState.allprojectList, projectyear);
        }
        console.log(projectyear);
        console.log(allprojetsState.allprojectList);
    }, [projectyear]);

    useEffect(() => {
        if (allprojetsState.allprojectList.length > 0) {
            setProjectList(allprojetsState.allprojectList);
        } else {
            setProjectList([]);
        }
    }, [allprojetsState, checkProject]);

    //useEffect(() => {
    //    console.log(allprojetsState);
    //    console.log(projectyear);
    //}, [allprojetsState, projectyear]);

    useEffect(() => {
        if (proId && proId !== '') setCheckProject(true);
    }, [proId]);

    const selectedYear = (value) => {
        setProjectyear(value.value);
        setViewingYear(value);
        // console.log(value.value);

    };



    const checkFinishReading = (value) => {
        setCheckProject(value);
        if (!value) {
            history.push({
                pathname: `${locationPath.pathname}`,
            });
        }
    };

    const getProID = (id) => {
        console.log(id);
        setClubProjecttId(id);
        //setProId(id);
        history.push({
            pathname: `${locationPath.pathname}`,
            search: `?_id=${id}`
        });
    };

    useEffect(() => {
        console.log(userState);
        if (userState.loggedUserData === null) {
            setCheckAdmin(false);
        } else {
            if (userState.loggedUserData.role === 'admin') {
                setCheckAdmin(true);
            }

        }
    }, [userState]);

    return (
        <div className="container-md" style={{ minHeight: '100vh' }}>
            <div className=' all-projects-container'>

                <div className='row all-projects-heading'>
                    <h1>
                        Our <span>Projects</span>
                    </h1>
                </div>
            </div>

            {
                checkAdmin &&
                <Link to='/admin-panel' className="link-deco-underline">
                    <div className="d-flex button-content-center pt-4 pb-1">
                        <Button buttonColour='light-grey'>Add Project</Button>
                    </div>
                </Link>
            }

            <div className={`project-selecting-section ${checkProject ? 'hide' : ''}`}>
                <div className='project-filter-selecting-section'>
                    <div className="col-md-2 mt-1"><MdDateRange className="date-icon" />
                        &nbsp;  Select <b> Project by Year</b>
                    </div>
                    <div className="col-md-3  col-sm-6 col-8">
                        <Select isClearable={false} options={yearOption} className="year-filterbar"
                            value={viewingYear}
                            onChange={value => selectedYear(value)}
                        />
                    </div>
                </div>

                <div className="container-md my-4">
                    <div class="d-flex flex-row align-content-start projectcardlist-align-center flex-wrap ">
                        {
                            projectList.map((project, index) => {
                                return (
                                    <div key={index}>
                                        <ProjectCard
                                            title={project.title}
                                            imgUri={project.thumbnailimageURL}
                                            id={project.id}
                                            getProID={getProID}
                                            checkFinishReading={checkFinishReading}

                                        />

                                    </div>
                                );
                            })
                        }

                        {
                            /*<div class="px-2 "><ProjectCard /></div>
                        <div class="px-2 "><ProjectCard /></div>
                        <div class="px-2 "><ProjectCard /></div>
                        <div class="px-2 "><ProjectCard /></div>
                        <div class="px-2 "><ProjectCard /></div>
                        <div class="px-2 "><ProjectCard /></div>*/
                        }
                    </div>
                </div>
            </div>
            <div
                className={`projects-collapse-btn-bar ${!checkProject ? 'hide' : ''}`}
                onClick={() => checkFinishReading(false)}>
                <div className="project-collapse-btn">
                    <span>See All Projects</span>
                </div>
            </div>
            <div>
                {
                    checkProject &&
                    <ProjectPage proId={proId} checkFinishReading={checkFinishReading} clubProjecttId={clubProjecttId} />
                }
            </div>
        </div>
    );
};

export default ProjectCardList;